import React, { Fragment } from 'react';
import T from 'prop-types';
import SimpleFormat from '@16g/react-simple-format';

import AppIcon from '../../../components/AppIcon';
import { numberToCurrency } from '../utils';
import helpers from '../../../utils/helpers';

const Summary = ({ store, data = {} }) => (
  <div className="widget-container about-page-summary">
    {data && data.name && (
      <Fragment>
        <div className="summary-top-content">
          <AppIcon
            containerClasses="summary-top-content-app-icon"
            alt={data.name}
            url={(data.icon_cdn_path || {})['128x128'] || data.icon_url}
            url2x={(data.icon_cdn_path || {})['128x128']}
            store={store}
            size={128}
          />
          <div className="summary-top-content-headings">
            <h1>{helpers.decodeEntities(data.name)}</h1>
            <h2>
              <SimpleFormat text={data.subtitle} />
            </h2>
          </div>
        </div>

        <div className="summary-bottom-content">
          <div className="summary-bottom-content-item">
            <span>Price</span>
            <div>
              <span>{data.price && data.price > 0 ? numberToCurrency(data.price) : 'Free'}</span>
              <a
                href={data.url}
                className="summary-bottom-content-store-link link-default"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className={store === 'google_play' ? 'hicon-play' : 'hicon-apple'} />
                {store === 'google_play' ? <span>GooglePlay</span> : <span>App Store</span>}
              </a>
            </div>
          </div>

          <div className="summary-bottom-content-item">
            <span>In-App Purchase</span>
            <span>{data.iap_present ? 'Yes' : 'No'}</span>
          </div>

          {store !== 'itunes_connect' && (
            <div className="summary-bottom-content-item">
              <span>Shows Ads</span>
              <span>{data.ads_present ? 'Yes' : 'No'}</span>
            </div>
          )}

          <div className="summary-bottom-content-item">
            <span>Launched</span>
            <span>{data.released_on_dev_date_formatted || data.released_date_formatted}</span>
          </div>

          <div className="summary-bottom-content-item">
            <span>Store Categories</span>
            <div className="store-categories-container">
              {(data.categories_list || []).map(
                ({ category_name, category_id, is_performance_available }, i) => (
                  <Fragment key={category_id}>
                    {i > 0 && <span className="store-categories-divider">|</span>}
                    {is_performance_available && (
                      <a className="link-default" href={`/categories/${store}/${category_id}`}>
                        {category_name}
                      </a>
                    )}
                    {!is_performance_available && <span>{category_name}</span>}
                  </Fragment>
                )
              )}
            </div>
          </div>
        </div>
      </Fragment>
    )}
  </div>
);

Summary.propTypes = {
  store: T.string.isRequired,
  data: T.shape({
    url: T.string,
    name: T.string,
    icon_url: T.string,
    icon_cdn_path: T.object,
    released_on: T.string,
    summary_title: T.string,
    subtitle: T.string,
    price: T.number,
    iap_present: T.bool,
    ads_present: T.bool,
    categories_list: T.array,
  }),
};

export default Summary;
